import { createFileRoute } from '@tanstack/react-router'
import BillingHistory from '../components/billing-projections/BillingHistory'

export const Route = createFileRoute('/_a/billingHistory')({
  component: BillingHistory,
})
